import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  ActiveCartOrderEntriesContext,
  AddedToCartDialogModule,
  CartDetailsModule,
  CartPageLayoutHandler,
  CartProceedToCheckoutModule,
  CartSharedModule,
  CartTotalsModule,
  ClearCartModule,
  SaveForLaterModule,
} from '@spartacus/cart/base/components';
import { ActiveCartOrderEntriesContextToken } from '@spartacus/cart/base/root';
import { PAGE_LAYOUT_HANDLER } from '@spartacus/storefront';

@NgModule({
  imports: [
    CommonModule,
    CartDetailsModule,
    CartProceedToCheckoutModule,
    CartTotalsModule,
    CartSharedModule,
    SaveForLaterModule,
    ClearCartModule,
  ],
  exports: [
    CartDetailsModule,
    CartProceedToCheckoutModule,
    CartTotalsModule,
    CartSharedModule,
    ClearCartModule,
    AddedToCartDialogModule,
    SaveForLaterModule,
  ],
  providers: [
    {
      provide: PAGE_LAYOUT_HANDLER,
      useExisting: CartPageLayoutHandler,
      multi: true,
    },
    {
      provide: ActiveCartOrderEntriesContextToken,
      useExisting: ActiveCartOrderEntriesContext,
    },
  ],
})
export class CartBaseComponentsModule {}
